import { OUTCOME_LABELS } from '@civilos/domain';
import { api } from '../shared/api.ts';
import { fmtDateTime } from '../shared/format.ts';
import { Link } from '../shared/router.tsx';
import { Card, Empty, ErrorBox, Spinner, useAction, useLoad } from '../shared/ui.tsx';

/** MOB-014: offline updates held for supervisor review. */
export function ReviewQueue() {
  const r = useLoad(() => api.get('/api/review/conflicts'));
  const a = useAction();
  const decide = (id: string, decision: 'apply' | 'reject') => {
    const note = window.prompt(decision === 'apply' ? 'Note (optional)' : 'Reason for rejecting (required)');
    if (decision === 'reject' && !note) return;
    a.run(async () => {
      await api.post(`/api/review/conflicts/${id}`, { decision, note });
      r.reload();
    });
  };
  return (
    <div className="stack">
      <h1>Offline conflicts</h1>
      <p className="muted">Offline attempts that could not be applied automatically. They are real-world events, so they are never dropped silently: apply them or reject them with a reason.</p>
      <ErrorBox error={a.error ?? r.error} />
      {r.loading && <Spinner />}
      {r.data?.conflicts.length === 0 && <Empty>No held offline updates.</Empty>}
      {r.data?.conflicts.map((c: any) => (
        <Card key={c.id} title={<Link to={`/papers/${c.paper_id}`}>{c.civilos_number}</Link>}>
          <p>
            <strong>{c.server_name}</strong> recorded <strong>{(OUTCOME_LABELS as any)[c.payload.outcome] ?? c.payload.outcome}</strong> offline at{' '}
            {fmtDateTime(c.payload.attemptedAt ?? c.created_at)}.
          </p>
          <p className="muted">Held because: {c.reason}</p>
          <p className="small muted">
            Device version {c.base_version}, server version {c.server_version}. Received {fmtDateTime(c.created_at)}.
          </p>
          <div className="row gap">
            <button className="btn primary" onClick={() => decide(c.id, 'apply')} disabled={a.busy}>
              Apply attempt
            </button>
            <button className="btn warn" onClick={() => decide(c.id, 'reject')} disabled={a.busy}>
              Reject
            </button>
          </div>
        </Card>
      ))}
    </div>
  );
}
